if (window.location.search.includes('country=')) {
    const params = new URLSearchParams(window.location.search);
    const targetCountry = params.get('country');
    params.delete('country');
    const clean = location.pathname + (params.toString() ? '?' + params : '') + location.hash;
    history.replaceState(null, '', clean);

    if (targetCountry) {
        document.querySelectorAll('a[href*="region_country"]').forEach(link => {
            try {
                const url = new URL(link.href);
                url.searchParams.set('region_country', targetCountry);
                link.href = url.toString();
            } catch (e) {}
        });
    }
}

const countrySwitcherForms = document.querySelectorAll("[data-country-selector]");
var delete_cookie = function(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const currentLanguage = (window.Shopify?.locale || '').split('-')[0].toUpperCase();

function getCurrentRelativePath() {
    const marketRoot = window.Shopify?.routes?.root || '/';
    const pathname = window.location.pathname;

    if (pathname.startsWith(marketRoot)) {
        return pathname.slice(marketRoot.length);
    }

    // AUB-702: "/en-us" (no trailing slash) or a Global-e segment ("/da-wo/…") unknown to routes.root:
    // drop the locale segment instead of carrying it into the target market (was /da-wo/en-us → Gone)
    const [firstSegment, ...rest] = pathname.replace(/^\//, '').split('/');

    return /^[a-z]{2}(-[a-z]{2,4})*$/.test(firstSegment) ? rest.join('/') : pathname.replace(/^\//, '');
}

function getTargetPath(button) {
    if (button.dataset.marketExcluded === 'true') {
        return '';
    }

    const localizedPaths = window.themeVariables?.localizedResourcePaths;

    if (localizedPaths) {
        return localizedPaths[button.dataset.language] || '';
    }

    return getCurrentRelativePath();
}

function getTargetParams(isoCode, targetLanguage) {
    const params = new URLSearchParams(window.location.search);
    params.delete('locale');

    if (targetLanguage !== currentLanguage) {
        Array.from(params.keys())
            .filter(key => key.startsWith('filter.'))
            .forEach(key => params.delete(key));
    }

    params.set('country', isoCode);

    return params;
}

async function submitLocalizationForm(form, isoCode, returnTo) {
    const countryCodeInput = form.querySelector('input[name="country_code"]');

    if (!countryCodeInput) {
        return false;
    }

    let returnToInput = form.querySelector('input[name="return_to"]');

    if (!returnToInput) {
        returnToInput = document.createElement('input');
        returnToInput.type = 'hidden';
        returnToInput.name = 'return_to';
        form.appendChild(returnToInput);
    }

    countryCodeInput.value = isoCode;
    returnToInput.value = returnTo;

    // AUB-702: wait for /localization to set the cookies before navigating, otherwise the page request
    // can win the race and Shopify resolves another country of the market (e.g. BG instead of DK).
    // redirect: 'manual' keeps AUB-690 (no visible 302) and skips the background render of return_to.
    try {
        await Promise.race([
            fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin',
                redirect: 'manual',
            }),
            new Promise(resolve => setTimeout(resolve, 1500)),
        ]);
    } catch (e) {}

    location.href = returnTo;

    return true;
}

// AUB-702: remember the country the visitor chose for each market folder. WO folders (/da-wo/, /en-wo/…)
// are shared by many countries: when the visitor comes back after browsing another market, Shopify
// resolves another WO country (e.g. BG): snippets/country-restore.liquid restores this choice before GTM loads.
const CHOSEN_COUNTRIES_KEY = 'aubade:chosen-countries';

function normalizeRoot(pathname) {
    return pathname.endsWith('/') ? pathname : pathname + '/';
}

function readChosenCountries() {
    try {
        return JSON.parse(localStorage.getItem(CHOSEN_COUNTRIES_KEY)) || {};
    } catch (e) {
        return {};
    }
}

function writeChosenCountries(chosenCountries) {
    try {
        localStorage.setItem(CHOSEN_COUNTRIES_KEY, JSON.stringify(chosenCountries));
    } catch (e) {}
}

window.aubadeRememberCountry = function(isoCode, marketPathname) {
    if (!isoCode || !marketPathname) {
        return;
    }

    const chosenCountries = readChosenCountries();
    chosenCountries[normalizeRoot(marketPathname)] = isoCode;
    writeChosenCountries(chosenCountries);
};

if (countrySwitcherForms && countrySwitcherForms.length) {
    countrySwitcherForms.forEach(form => {
        const buttons = form.querySelectorAll('button[name="country_code--button"]');
        buttons.forEach(button => {
            button.addEventListener("click", async event => {
                try {
                    const isoCode = button.value;

                    const marketRoot = new URL(button.getAttribute('data-shop'));
                    marketRoot.search = '';
                    marketRoot.hash = '';

                    if (!marketRoot.pathname.endsWith('/')) {
                        marketRoot.pathname += '/';
                    }

                    const currentRoot = new URL(window.Shopify?.routes?.root || '/', window.location.origin);

                    // AUB-702: WO countries share /en-wo and /fr-wo, so the same root is not the same country
                    if (
                        marketRoot.hostname === currentRoot.hostname &&
                        marketRoot.pathname === currentRoot.pathname &&
                        isoCode === window.Shopify?.country
                    ) {
                        return;
                    }

                    const targetUrl = new URL(getTargetPath(button), marketRoot);
                    targetUrl.search = getTargetParams(isoCode, button.dataset.language).toString();
                    targetUrl.hash = window.location.hash;

                    delete_cookie('localization');

                    if (targetUrl.hostname === window.location.hostname) {
                        window.aubadeRememberCountry(isoCode, marketRoot.pathname);

                        if (await submitLocalizationForm(form, isoCode, targetUrl.pathname + targetUrl.search + targetUrl.hash)) {
                            return;
                        }
                    }

                    location.href = targetUrl.toString();
                } catch (e) {
                    console.error('Country switcher failed', e);
                }
            });
        });
    });

}

// Apply order to all language selectors

const allLanguageSelectors = document.querySelectorAll('[id^="language_selector-"]');
  allLanguageSelectors.forEach(selector => {
    addOrderAttributes(selector);
  });

function addOrderAttributes(parentDiv) {
  const eligibleChildren = parentDiv.querySelectorAll(':scope > :not([data-is-glopal="true"])');

  eligibleChildren.forEach((child, index) => {
    child.setAttribute('style', `order: ${index + 1}`);
  });
}